import * as React from "react";
import Dialog from "@mui/material/Dialog";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import CloseIcon from "@mui/icons-material/Close";
import Slide from "@mui/material/Slide";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import Button from "@mui/material/Button";
import Avatar from "@mui/material/Avatar";
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";

// Transition for the slide animation
const Transition = React.forwardRef(function Transition(
  props, // No type annotations here
  ref
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const CodeDialog = ({ openQRCode, handleCloseQRCode }) => {
  return (
    <Dialog
      fullScreen
      open={openQRCode}
      onClose={handleCloseQRCode}
      TransitionComponent={Transition}
    >
      <AppBar sx={{ position: "relative" }}>
        <Toolbar sx={{ display: "flex", justifyContent: "flex-end" }}>
          <Typography
            sx={{ ml: 2, flex: 1, textAlign: "center" }}
            variant="h6"
            component="div"
          >
            Bagikan Kode QR
          </Typography>
          <IconButton
            edge="end"
            color="inherit"
            onClick={handleCloseQRCode}
            aria-label="close"
          >
            <CloseIcon />
          </IconButton>
        </Toolbar>
      </AppBar>
      <Box sx={{ p: 2, borderRadius: 3, bgcolor: "#f5f5f5", mb: 2 }}>
        {/* Icon Email di tengah */}
        <Box display="flex" justifyContent="center" mb={2}>
          <Avatar sx={{ bgcolor: "rgba(33, 150, 243, 0.1)", color: "#2196f3" }}>
            <EmailOutlinedIcon />
          </Avatar>
        </Box>

        <Typography
          variant="body2"
          fontWeight="bold"
          color="text.primary"
          gutterBottom
          sx={{ mb: 2 }}
        >
          Dikirim Ke
        </Typography>

        {/* TextField untuk Email */}
        <TextField
          fullWidth
          size="small"
          variant="outlined"
          type="email"
          placeholder="email@example.com"
          label="Alamat Email"
          sx={{
            mb: 2,
            bgcolor: "#fff",
            borderRadius: 2,
            "& .MuiOutlinedInput-root": {
              borderRadius: 2,
            },
          }}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <EmailOutlinedIcon color="action" />
              </InputAdornment>
            ),
          }}
        />

        {/* Tombol Kirim */}
        <Button
          variant="contained"
          fullWidth
          sx={{
            textTransform: "none",
            bgcolor: "#424242",
            borderRadius: 5,
            ":hover": {
              bgcolor: "#08306b",
            },
          }}
        >
          Kirim Kode QR
        </Button>
      </Box>
    </Dialog>
  );
};

export default CodeDialog;
